import { render, staticRenderFns } from "./c-toast.vue?vue&type=template&id=5067b468&scoped=true"
import script from "./c-toast.vue?vue&type=script&lang=js"
export * from "./c-toast.vue?vue&type=script&lang=js"
import style0 from "./c-toast.vue?vue&type=style&index=0&id=5067b468&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067b468",
  null
  
)

export default component.exports